import React, {useEffect, useState} from "react";
import {TabStrip, TabStripTab} from '@progress/kendo-react-layout';
import ProfilePage from "./ProfilePage";
import "./AdminTabsPage.css";
import RolesPage from "../Components/Permission/RolesPage";

import UsersPermissionsDashboard from "../Components/Permission/UsersPermissionsDashboard";
import GroupsPermissionsDashboard from "../Components/Permission/GroupsPermissionsDashboard";
// import RolesPermissionsDashboard from "../Components/Permission/RolesPermissionsDashboard";

//@ts-ignore
// import {AccountDetails as AccountDetailsSetup} from "../Setup/Pages/AccountsDetails";
//import AccountDetailsSetup from "../Setup/Pages/AccountsDetailsSetupOld";
import FTPS3DashV3 from "./FTPS3DashV3.tsx";
import {getFTPSettings} from "../../actions/OnBoardingActions";
// import AccountPricing2 from "../Setup/Pages/AccountPricing";
import AppStatus from "../Setup/Pages/AppStatus";
import Billing from "../Setup/Pages/Billing";
import JobStatus from "../Setup/Pages/JobStatus";
import NotificationDashboard from "./NotificationDashboard";
import AccountDashboard from "../Setup/Pages/AccountDashboard";
import IdxTagManager from "./IdxTagManager";
import {UserContext} from "../../contexts/UserContext";
import SystemNotificationCreator from "../Components/SystemNotificationCreator";
import AdminIdxTagManager from "./AdminIdxTagManager";
import AdminCreativeTagManager from "./AdminCreativeTagManager";
import IdentityPipeline from "./IdentityPipeline/IdentityPipeline";
import AdminIdentityPipeline from "./AdminIdentityPipeline";
import {semcastAxios, showErrorToastMessage} from "../../Utils/Common";
import {GROUPS_ACCESSIBLE_PIXELS} from "../../api/constants";

const AdminTabsPage = () => {
    const {user, setUser} = React.useContext(UserContext);

    const [selected, setSelected] = React.useState(sessionStorage.getItem('adminTabSelected') || 0);
    // const [user, setUser] = React.useState(JSON.parse(sessionStorage.getItem(USER)) || null);
    const isToolboxLogged = sessionStorage.getItem("isToolboxLogged");
    const [allConnDash, setAllConnDash] = useState([]);
    const [selectedTagTab, setSelectedTagTab] = React.useState(0);
    const [userIsGrpAdmin, setUserIsGrpAdmin] = useState(false);
    const [pipelineAllowedUsers, setPipelineAllowedUsers] = useState([2885, 3648, 3474]);

    const getAllSavedSettingsDashboard = async () => {
        getFTPSettings().then((res) => {
            if (res && res.data.length) {
                let allConnectionsDash = res.data;
                allConnectionsDash.forEach((conn) => {
                    if (conn.transfer_protocol === "ftps" || conn.transfer_protocol === "sftp") {
                        conn.ftps3 = "FTP";
                    } else {
                        conn.ftps3 = "S3";
                    }
                })
                setAllConnDash(allConnectionsDash);
            }
        })
    }
    const userIsGroupAdmin = () => {

        try {
            //return groups that the current user is a Admin of
             semcastAxios.get(GROUPS_ACCESSIBLE_PIXELS, {withCredentials: true})
                .then((res) => {
                    if(res.data.data.length > 0){
                        setUserIsGrpAdmin(true)
                    }

                })
        } catch (error) {
            console.log(error)
            showErrorToastMessage("Error accessing Group information. " + error);
        }

    }
useEffect(() => {
    userIsGroupAdmin();
})

    const handleSelect = e => {
        sessionStorage.setItem('adminTabSelected', e.selected);
        setSelected(e.selected);
    };
    const handleTagTabSelect = e => {
        setSelectedTagTab(e.selected);
    };

    const [selected2, setSelected2] = React.useState(sessionStorage.getItem('permissionsTabSelected') || 0);

    const handleSelect2 = e => {

        sessionStorage.setItem('permissionsTabSelected', e.selected);
        setSelected2(e.selected);
    };

    useEffect(() => {
        let adminTab = parseInt(sessionStorage.getItem('adminTabSelected'));
        let permTab = parseInt(sessionStorage.getItem('permissionsTabSelected'));

        if (typeof adminTab === 'number' && adminTab >= 0 && adminTab <= 5) setSelected(adminTab);
        else setSelected(0);

        if (typeof permTab === 'number' && permTab >= 0 && permTab <= 2) setSelected2(permTab);
        else setSelected2(0);


        getAllSavedSettingsDashboard();
    }, []);
    useEffect(() => {
        const user = sessionStorage.getItem('user');
        if (user?.isAdmin) {
            document.body.className = 'lightgoldenrodyellow';
        }

    }, []);
    const style = {
        backgroundColor: 'red !important',
    };
    const isToolbox = JSON.parse(sessionStorage.getItem('isToolboxLogged'));
    const tempStyle = `.admin-tabstrip-container-card .k-item:nth-child(5)
                        {
                        background-color: lightgoldenrodyellow !important;
                        }
                     `;
    return (
        <div>
            {/*adding yellow tab styles when page loads*/}
            {isToolbox ? <></> : <style>{tempStyle}</style>}
            <div
                className={"section-card admin-tabstrip-container-card box-shadow-standard section-card-outer-margins"}>
                <TabStrip selected={selected} onSelect={handleSelect} tabPosition={"top"}>
                    <TabStripTab title="Profile" contentClassName={"admin-tabstrip-user"}>
                        <ProfilePage/>
                    </TabStripTab>

                    <TabStripTab title="Permissions">
                        <TabStrip selected={selected2} onSelect={handleSelect2} tabPosition={"left"}>
                            <TabStripTab title="Users">

                                <UsersPermissionsDashboard>

                                </UsersPermissionsDashboard>

                            </TabStripTab>
                            <TabStripTab title="Groups">

                                <GroupsPermissionsDashboard>

                                </GroupsPermissionsDashboard>

                            </TabStripTab>

                            {user?.isAdmin && <TabStripTab title="Roles">

                                <div>
                                    <RolesPage/>
                                </div>
                            </TabStripTab>
                            }
                        </TabStrip>
                    </TabStripTab>
                    <TabStripTab title="Connections Manager">

                        <div>
                            <FTPS3DashV3 allConnDash={allConnDash} setAllConnDash={setAllConnDash}
                                         getAllSavedSettingsDashboard={getAllSavedSettingsDashboard}></FTPS3DashV3>
                        </div>

                    </TabStripTab>
                    {/*visible to Toolbox and group Admins only*/}
                    {sessionStorage.isToolboxLogged && (user.isAdmin || pipelineAllowedUsers.includes(Number(user.id))) && <TabStripTab title="Identity Pipeline">
                        <div>
                            <IdentityPipeline/>
                        </div>
                    </TabStripTab>}
                    {/*<TabStripTab title="ADX Tag Manager">*/}
                    {/*    <div>*/}
                    {/*        <AdxTagManager/>*/}
                    {/*    </div>*/}
                    {/*</TabStripTab>*/}
                    {/*FD:13555*/}
                    {sessionStorage.isToolboxLogged && <TabStripTab title="IDX Tag Manager">
                        <div>
                            <IdxTagManager/>
                        </div>
                    </TabStripTab>
                    }
                    <TabStripTab title="Notifications">
                        <div>
                            <NotificationDashboard/>
                        </div>
                    </TabStripTab>

                    {user?.isAdmin && <TabStripTab title="App Status" contentClassName="adminTab">
                        <div>
                            <AppStatus/>
                        </div>
                    </TabStripTab>
                    }
                    {user?.isAdmin && <TabStripTab title="Billing">
                        <div>
                            <Billing/>
                        </div>
                    </TabStripTab>
                    }

                    {user?.isAdmin && <TabStripTab title="Job Status">
                        <div>
                            <JobStatus/>
                        </div>
                    </TabStripTab>
                    }
                    {sessionStorage.isToolboxLogged && user?.isAdmin && <TabStripTab title="Tags">
                        <div className={"tag-outter-wrap"} style={style}>
                            <TabStrip selected={selectedTagTab} onSelect={handleTagTabSelect} tabPosition={"top"}>
                                <TabStripTab title="IDX Tags">
                                    <div>
                                        <AdminIdxTagManager/>
                                    </div>
                                </TabStripTab>
                                <TabStripTab title="Creative Tags">
                                    <div>
                                        <AdminCreativeTagManager/>
                                    </div>
                                </TabStripTab>
                                <TabStripTab title="Identity Pipeline">
                                    <div>
                                        <AdminIdentityPipeline/>
                                    </div>
                                </TabStripTab>
                            </TabStrip>

                        </div>
                    </TabStripTab>}
                    {user?.isAdmin && <TabStripTab title="Account">
                        <div>
                            <AccountDashboard create={false}/>
                        </div>
                    </TabStripTab>
                    }
                    {/*{user?.isAdmin && <TabStripTab title="Account">*/}
                    {/*    <div>*/}
                    {/*        <AccountDetailsSetup create={false}/>*/}
                    {/*    </div>*/}
                    {/*</TabStripTab>*/}
                    {/*}*/}
                    {user?.isAdmin && <TabStripTab title="Users">
                        <div>
                            <UsersPermissionsDashboard isFromAccount={true}/>
                        </div>
                    </TabStripTab>
                    }
                    {/* System Notifactions*/}
                    {user?.isAdmin && (
                        <TabStripTab title="System Notifications">
                            <div>
                                <SystemNotificationCreator/>
                            </div>
                        </TabStripTab>
                    )}

                </TabStrip>
            </div>
        </div>
    )
}

export default AdminTabsPage;